import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入样式，这里的theme-chalk是默认主题，也可换其他主题

// 导入封装的axios
import requests from './api/index'
// 将requests挂载到Vue原型上，这样在所有Vue实例（包括组件）中都可以通过this.$http访问到
Vue.prototype.$http = requests

Vue.prototype.$url = 'https://yulixx.hahatao.top'

Vue.use(ElementUI);

Vue.config.productionTip = false;

// 监听路由变化
router.afterEach((to, from) => {
  document.title = to.meta.title || '昱栎';
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');